import { render, staticRenderFns } from "./ComponentBuildModal.vue?vue&type=template&id=f0f83aea&scoped=true&"
import script from "./ComponentBuildModal.vue?vue&type=script&lang=js&"
export * from "./ComponentBuildModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentBuildModal.vue?vue&type=style&index=0&id=f0f83aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f83aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VCol,VForm,VRow,VTextField,VTextarea})
